import { useNavigate } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Carousel } from "../components/Carousel";
import { Shapes } from "../components/Shapes";
import { Editorial } from "../components/Editorial";
import { Reviews } from "../components/Reviews";
import { Contact } from "../components/Contact";
import { usePageMeta } from "../lib/usePageMeta";

export default function Home() {
  const navigate = useNavigate();
  usePageMeta(
    "Lab Grown Diamonds Hyderabad | CVD & HPHT Diamond Dealer Abids – Padmavati Gem & Jewelss",
    "Padmavati Gem & Jewelss, Abids Hyderabad: IGI certified lab grown diamonds, CVD and HPHT melee and solitaires for jewellers and buyers. Wholesale and retail, GST invoice, WhatsApp enquiry."
  );
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Carousel />
      <Shapes number="01" onPick={(s) => navigate(`/browse?shape=${s}`)} />
      <Editorial />
      <Reviews />
      <Contact />
    </main>
  );
}
